<template>
  <v-container grid-list-md>
    <!-- thrending Ideas -->
    <div>
      <v-row justify="start" align="center">
        <div>
          <span class="headline">Thrending Ideas</span>
          <div>
            <span class="body-2">List of mostly voted Code Night Project ideas</span>
          </div>
        </div>
        <v-divider></v-divider>
        <v-btn
        dark
          class="mr-5 teal elevation-10"
          v-show="threndingIdeas.length > 0"
          outlined
          @click="showAllIdeas"
        >
          <span class="subheading">Show all ideas</span>
        </v-btn>
      </v-row>
      <!-- Slider -->
      <!-- If there are ideas -->
      <v-sheet class="mx-auto" flat width="100%" v-show="threndingIdeas.length > 0">
        <v-slide-group
          v-model="model"
          :prev-icon="prevIcon ? 'mdi-minus' : undefined"
          :next-icon="nextIcon ? 'mdi-plus' : undefined"
          :multiple="multiple"
          :mandatory="mandatory"
          :show-arrows="showArrows"
          :center-active="centerActive"
          color="black"
        >
          <v-slide-item
            v-for="(id, n) in threndingIdeas"
            :key="n"
            v-slot:default="{ active, toggle }"
          >
            <ideaCard class="ma-4" :idea="id"></ideaCard>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
      <!-- If there is no idea at all -->
      <v-container
        style="margin: 80px 0px"
        bg
        fill-height
        grid-list-md
        text-xs-center
        v-show="allIdeas.length < 1"
      >
        <v-row align="center" justify="center">
          <v-card class="elevation-10" style="border-radius: 5\7px">
            <v-container grid-list-md justify="center">
              <div>
                <span class="headline">Oops! There are no Thrending Project Ideas!</span>
              </div>
              <div>
                <span class="body-2">You can always submit an idea, FYI!</span>
              </div>
            </v-container>
          </v-card>
        </v-row>
      </v-container>
    </div>
    <!-- My Ideas -->
    <ideaEditor></ideaEditor>
    <div class="mt-5">
      <v-row justify="start" align="center" class="mb-2">
        <div>
          <span class="headline">Your Ideas</span>
          <div>
            <span class="caption"></span>
          </div>
        </div>
        <v-divider></v-divider>
        <v-btn dark class="mr-5 teal elevation-10" outlined @click="createItem">
          <v-icon>mdi-plus</v-icon>
          <span>Add New Idea</span>
        </v-btn>
      </v-row>
      <!-- If there is idea at all -->
      <v-sheet class="mx-auto" flat width="100%" v-show="myIdeas.length > 0">
        <v-slide-group
          v-model="model"
          :prev-icon="prevIcon ? 'mdi-minus' : undefined"
          :next-icon="nextIcon ? 'mdi-plus' : undefined"
          :multiple="multiple"
          :mandatory="mandatory"
          :show-arrows="showArrows"
          :center-active="centerActive"
          color="black"
        >
          <v-slide-item v-for="(id, n) in myIdeas" :key="n" v-slot:default="{ active, toggle }">
            <myIdeaCard class="ma-4" :idea="id"></myIdeaCard>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>

      <!-- If there is no idea at all -->
      <v-container
        style="margin: 80px 0px"
        bg
        fill-height
        grid-list-md
        text-xs-center
        v-show="myIdeas.length < 1"
      >
        <v-row align="center" justify="center">
          <v-card class="elevation-10" style="border-radius: 5\7px">
            <v-container grid-list-md justify="center">
              <div>
                <span class="headline">Oops! You haven't submited any Project Idea, yet!</span>
              </div>
              <div>
                <span
                  class="body-2"
                >It looks like you need to use the button on the right to submit new Idea.</span>
              </div>
            </v-container>
          </v-card>
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import ideaCard from "@/components/IdeaCard";
import myIdeaCard from "@/components/MyIdeaCard";
import ideaEditor from "@/components/IdeaEditor";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  components: {
    ideaCard,
    myIdeaCard,
    ideaEditor
  },
  data: () => ({
    model: null,
    multiple: false,
    mandatory: true,
    showArrows: true,
    prevIcon: false,
    nextIcon: false,
    centerActive: true,
    ideas: [
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      },
      {
        title: "Title-1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        up: 13,
        down: 4
      }
    ],
    anIdea: {},
    response: [],
    errors: []
  }),
  created() {
    this.getAllIdeas();
    this.getAllMyIdeas(this.user._id);
    this.getAllThrendingIdeas();
  },
  computed: {
    ...mapGetters("idea", ["_getAllIdeas", "_getMyIdeas"]),
    ...mapState("idea", ["myIdeas", "allIdeas", "threndingIdeas"]),
    ...mapState("auth", ["token", "user"])
  },
  methods: {
    ...mapActions("idea", [
      "getAllIdeas",
      "getAllMyIdeas",
      "getAllThrendingIdeas"
    ]),
    ...mapMutations("idea", ["setDialog", "setEditedIdea"]),
    createItem() {
      this.setDialog(true);
    },
    showAllIdeas() {
      this.$router.push("/idea-list");
    }
  }
};
</script>